import RealTimeReport from './container';

export default RealTimeReport;



// WEBPACK FOOTER //
// ./src/views/RealTimeReport/index.js